import authRules from '../authRules';

const viewAssignmentSalaryLevelAndUpgrade = (user) => {
  const { massiveApprovalsSalary } = user.securityLevels;
  if (massiveApprovalsSalary >= authRules.viewAssignmentSalaryLevelAndUpgrade.massiveApprovalsSalary) {
      return true;
  } else {
      return false;
    }
  }


export default viewAssignmentSalaryLevelAndUpgrade;


// WEBPACK FOOTER //
// ./src/AuthLogic/rules/viewAssignmentSalaryLevelAndUpgrade.js